import Link from 'next/link'

import { Advice } from '../types'

interface Props {
  advice: Advice
  allTopics: string[][]
  categoryColours: { title: string; colour: string }[]
}

export function TopicsCell(props: Props) {
  const { advice, allTopics, categoryColours } = props

  return (
    <table key={advice.title} className="w-full">
      <tbody>
        {advice.categories &&
          advice.categories.map((cat, i) => (
            <tr
              key={cat.title}
              className={
                i === advice.categories.length - 1
                  ? ''
                  : `border-b border-gray-300 `
              }
            >
              <td className="8/12">
                <div className="flex flex-wrap ">
                  {allTopics
                    .filter((t) => t[1] === cat.title)
                    .filter((t) =>
                      advice.topics
                        .map((adviceTopic) => adviceTopic.title)
                        .includes(t[0]),
                    )
                    .map((top) => {
                      const colour = categoryColours.find(
                        (c) => c.title === cat.title,
                      )?.colour
                      return (
                        <Link
                          title={cat.title}
                          key={advice.slug + top[0]}
                          className={`bg-${colour}-50 text-blue-700 text-nowrap rounded-full px-2 py-1 text-xs mr-2 my-1`}
                          href={`/${cat.slug}/${advice.topics[0].slug}`}
                        >
                          {top[0]}
                        </Link>
                      )
                    })}
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}
